// ADD API URLS BELOW
export const API_URLS = {
    searchSubmit: '/search-results',
    searchTypeahead: '/umbraco/api/searchapi/gettypeahead',
    // Listings
    mortgagesListing: '/umbraco/api/mortgagesapi/getmortgages',
    newsListing: '/api/newsapi/getnews',
    savingsListing: '/umbraco/api/savingsapi/getsavings',
    searchResults: '/umbraco/api/searchapi/search',
    vacancyListing: '/api/vacancyapi/getvacancies',
    // Forms
    affordabilityCalculator: '/api/calculatorsapi/affordability-calculator',
    buyToLetRentalIncomeCalculator: '/api/calculatorsapi/buytolet-rental-income-calculator',
    decisionInPrinciple: '/api/multistepforms/submit',
    savingsInterestCalculator: '/api/calculatorsapi/savings-interest-calculator',
};
